import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { ColapsePanel } from '../core/ColapsePanel';
import { CMS } from '../shared/index';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
import { isNull } from '../utils/index';
export interface FAQsProps extends BaseComponentProps {
    lang: string;
}

export interface FAQsState extends BaseComponentState {
    faqs: CMS.CmsFAQ[] ;
}

export class FAQs extends BaseComponent<FAQsProps, FAQsState> {

    constructor(props: FAQsProps) {
        super(props); 
        this.getPromotion();
    }

    getPromotion() {
        getAjaxhelper().post(`/dynamics/rest-api/generic/CmsFAQ`, {
            eraseAuditTrail: true,
        }).then((data) => {
            if (!isNull(data.rows)) {
                this.setState({ faqs: data.rows });
            }
        }).catch(exc => {
            console.log(exc);
        });
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let page = [];

        if (!isNull(this.state.faqs)) {
            for (let faq of this.state.faqs) {
                page.push(
                    <ColapsePanel
                        key={`faq_${faq.id}`}
                        title={faq.question!}
                        component={faq.answer}
                        colapse={false}
                        border={false}
                    />
                );
            }

        }

        return (
            <div>
                <h3 style={{marginBottom: 30}}>Bali Hotels and More FAQs</h3>
                 {page}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/FAQs.tsx